import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { PenaltyReminderSettingsButton } from '@frontend/features/travel-services/components/PenaltyReminderSettingsButton';

export const BookingSettingsView = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  return (
    <Box sx={{ bgcolor: 'background.paper', borderRadius: 3, p: 3 }}>
      <Typography variant="h5" mb={2}>
        {t('bookingSettings.title')}
      </Typography>
      <PenaltyReminderSettingsButton key={id} agencyId={Number(id)} />
    </Box>
  );
};
